import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { especialidadesColumns } from './columns/_columns'
import { EspecialidadeView } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const EspecialidadesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => especialidadesColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.nome
          ? `Nenhuma especialidade encontrada para “${filters.nome}”`
          : 'Nenhuma especialidade para este tipo de atendimento'
      }
      description='Revise o termo digitado ou o tipo de atendimento selecionado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma especialidade cadastrada'
      description='Use “Adicionar” para cadastrar a primeira especialidade.'
    />
  )

  return (
    <CustomTable<EspecialidadeView>
      id='kt_table_especialidades'
      ariaLabel={t('especialidade.plural')}
      itemLabel={{
        singular: t('especialidade.label.lowercase'),
        plural: t('especialidade.plural.lowercase'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
